import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import PropertyFormat, {
    amountFormat,
    DateFormatWithTime,
    RemoveUnderscoreWithUppercase,
} from '../PropertyFormat/PropertyFormat';
import {
    getAmountFundedTillDate,
    getBuyerAverageCreditLimit,
} from '../../../redux/actions/facilityApi';
import {
    getAllPorts,
    getAllUserBuyer,
    getAllUserSupplier,
} from '../../../redux/actions/rfqManagementApi';
import { getBuyerStats, getSupplierStats } from '../../../redux/actions/userManagementApi';
import { getTotalCODAmount, getTotalMTTraded } from '../../../redux/actions/transactionApi';
import { Link } from 'react-router-dom';
import { isOpenKnotsEnabled } from '../../../config/openKnotsFeature';
import { showPricingConfigurator } from '../Sidebar/Sidebar.helpers';

export const isTruthyEnvFlag = (value) => String(value) === 'true';

export const getPlatformRole = (userData) =>
    userData?.user_organizations?.[0]?.user_org_role_maps?.[0]?.platform_role;

export const getDashboardPath = (userData) => {
    const role = getPlatformRole(userData);
    if ((role === 'buyer' || role === 'supplier') && isOpenKnotsEnabled(userData)) {
        return '/dashboard?type=openKnots';
    }
    return '/dashboard';
};

const pageClass = (isActive) => (isActive ? 'page-active' : 'page-inactive');

const HeaderMobileBuyerSupplierNav = ({ ctx, onSidebarClick }) => {
    const [isAccountOpen, setIsAccountOpen] = useState(false);
    return (
        <>
            <p
                className={`pt-3 pb-2 font-b2 mb-0 cursor border-top-gray mt-2 ${pageClass(
                    ctx.pageActive === 'myProfile' || ctx.pageActive === 'myRequests'
                )}`}
                role='button'
                aria-expanded={isAccountOpen}
                onClick={() => setIsAccountOpen((open) => !open)}>
                <span className='sf-user home-icon'></span>
                <span>My Account</span>
                <span className='sf-chevron-down float-end me-3 mt-1 pt-1'></span>
            </p>
            {isAccountOpen && (
                <div onClick={onSidebarClick}>
                    <Link to='/requests'>
                        <p className='font-b2 ps-4 ms-2 cursor mt-2'>
                            <i className='bi bi-circle-fill me-2'></i> My Requests
                        </p>
                    </Link>
                    <Link to='/myProfile'>
                        <p className='font-b2 ps-4 ms-2 cursor'>
                            <i className='bi bi-circle-fill me-2'></i> My Profile
                        </p>
                    </Link>
                    <Link to='/userAssignment'>
                        <p className='font-b2 ps-4 ms-2 cursor'>
                            <i className='bi bi-circle-fill me-2'></i>User Assignment
                        </p>
                    </Link>
                </div>
            )}
        </>
    );
};

const HeaderMobileOpsNav = ({ ctx, onSidebarClick }) => {
    const showMyAccount = isTruthyEnvFlag(process.env.REACT_APP_SHOW_USER_ASSIGNMENT);
    const [isAccountOpen, setIsAccountOpen] = useState(false);
    return (
        <>
            <Link to='/dashboard?tab=transactions'>
                <p
                    className={`pt-3 pb-2 font-b2 mb-0 cursor border-top-gray ${pageClass(
                        ctx.pageActive === 'allTransactions'
                    )}`}
                    onClick={onSidebarClick}>
                    <span className='sf-all-transaction home-icon'></span>
                    <span>All Transactions</span>
                </p>
            </Link>
            <Link to='/dashboard?tab=requests'>
                <p
                    className={`pt-3 pb-2 font-b2 mb-0 cursor ${pageClass(ctx.pageActive === 'allRequests')}`}
                    onClick={onSidebarClick}>
                    <span className='sf-my-requests home-icon'></span>
                    <span>All Requests</span>
                </p>
            </Link>
            <Link to='/manageProfiles'>
                <p
                    className={`pt-2 pb-2 font-b2 mb-0 cursor mt-2 ${pageClass(ctx.pageActive === 'profile')}`}
                    onClick={onSidebarClick}>
                    <span className='sf-manage-profile home-icon'></span>
                    <span>Manage Profile</span>
                </p>
            </Link>
            <Link to='/facilities'>
                <p
                    className={`pt-2 pb-2 font-b2 mb-0 cursor mt-2 ${pageClass(ctx.pageActive === 'allFacilities')}`}
                    onClick={onSidebarClick}>
                    <span className='sf-all-facilities home-icon'></span>
                    <span>All Facilities</span>
                </p>
            </Link>
            {showPricingConfigurator(ctx.userData) && (
                <Link to='/pricingConfigurator'>
                    <p
                        className={`pt-2 pb-2 font-b2 mb-0 cursor mt-2 ${pageClass(
                            ctx.pageActive === 'pricingConfigurator'
                        )}`}
                        onClick={onSidebarClick}>
                        <span className='sf-pricing-conf home-icon'></span>
                        <span>Pricing Configurator</span>
                    </p>
                </Link>
            )}
            {showMyAccount ? (
                <>
                    <p
                        className={`pt-2 pb-2 font-b2 mb-0 cursor border-top-gray mt-2 ${pageClass(
                            ctx.pageActive === 'notifications' || ctx.pageActive === 'userAssignment'
                        )}`}
                        role='button'
                        aria-expanded={isAccountOpen}
                        onClick={() => setIsAccountOpen((open) => !open)}>
                        <span className='sf-user home-icon'></span>
                        <span>My Account</span>
                        <span className='sf-chevron-down float-end me-3 mt-1 pt-1'></span>
                    </p>
                    {isAccountOpen && (
                        <div onClick={onSidebarClick}>
                            <Link to='/notifications'>
                                <p className='font-b2 ps-4 ms-2 cursor mt-2'>
                                    <i className='bi bi-circle-fill me-2'></i>Notifications
                                </p>
                            </Link>
                            <Link to='/userAssignment'>
                                <p className='font-b2 ps-4 ms-2 cursor'>
                                    <i className='bi bi-circle-fill me-2'></i>User Assignment
                                </p>
                            </Link>
                        </div>
                    )}
                </>
            ) : null}
        </>
    );
};

export const HeaderMobileNav = ({ ctx, showSideBar, onSidebarClick, onLogout }) => {
    const platformRole = getPlatformRole(ctx.userData);
    const showBuyerSupplierNav = ctx.userData && (platformRole === 'buyer' || platformRole === 'supplier');
    const showOpsNav = ctx.userData && (platformRole === 'internal_ops' || platformRole === 'admin');

    return (
        <div className={`mwen-nav ${showSideBar ? 'd-block' : 'd-none'}`}>
            <Link to={getDashboardPath(ctx.userData)}>
                <p className='pt-3 pb-2 font-b2 cursor mb-0' onClick={onSidebarClick}>
                    <span className='sf-home home-icon'></span>
                    <span>Home</span>
                </p>
            </Link>
            {showBuyerSupplierNav ? <HeaderMobileBuyerSupplierNav ctx={ctx} onSidebarClick={onSidebarClick} /> : null}
            {showOpsNav ? <HeaderMobileOpsNav ctx={ctx} onSidebarClick={onSidebarClick} /> : null}
            <p className='pt-3 pb-2 font-b2 cursor mb-0' onClick={onLogout}>
                {' '}
                <span className='bi bi-circle-fill home-icon'></span>
                <span>Logout</span>
            </p>
        </div>
    );
};

export const getOrgName = (userData) => userData?.user_organizations?.[0]?.name;

export const getNotificationCategoryClass = (category) => {
    if (category === 'action') {
        return 'color-0';
    }
    if (category === 'chat_message') {
        return 'color-1';
    }
    return 'color-2';
};

export const getNotificationItemKey = (el) =>
    el?.ulid || `${el?.notification_category}-${el?.created_at}-${el?.payload?.notification}`;

export const shouldShowBuyerSupplierRequests = (role, showRequestMangIcons) => {
    if (role === 'internal_ops') {
        return true;
    }
    if (!['buyer', 'supplier'].includes(role)) {
        return false;
    }
    return isTruthyEnvFlag(showRequestMangIcons) && process.env.NODE_ENV !== 'production';
};

/** OPEN / BAAS / Trade Support host header — request mgmt and settings not implemented yet (APPLICATIO-3657). */
export const shouldHideOpenKnotsRequestAndSettingsHeaderIcons = (usesOpenKnotsHeader, role) =>
    Boolean(usesOpenKnotsHeader) && (role === 'buyer' || role === 'supplier');

export const shouldShowBrokerRequests = (role, showRequestMangIcons) => {
    const matchesBrokerEnv =
        ['broker'].includes(role) &&
        isTruthyEnvFlag(showRequestMangIcons) &&
        process.env.NODE_ENV !== 'production';
    if (matchesBrokerEnv) {
        return true;
    }
    return role !== 'internal_ops';
};

export const dispatchHeaderStatsByRole = (dispatch, orgUlid, platformRole) => {
    const req = {
        params: null,
        isLoadMore: false,
    };
    if (!orgUlid) {
        return;
    }
    if (platformRole === 'buyer') {
        dispatch(getAmountFundedTillDate(orgUlid));
        dispatch(getBuyerStats(orgUlid));
        dispatch(getAllPorts(req));
        dispatch(getAllUserSupplier());
        dispatch(getBuyerAverageCreditLimit());
        return;
    }
    if (platformRole === 'supplier') {
        dispatch(getAmountFundedTillDate(orgUlid));
        dispatch(getSupplierStats(orgUlid));
        dispatch(getAllUserBuyer());
        dispatch(getTotalMTTraded());
        dispatch(getTotalCODAmount());
        return;
    }
    if (platformRole === 'broker') {
        dispatch(getAmountFundedTillDate(orgUlid));
        dispatch(getAllUserBuyer());
    }
};

const BuyerHeaderStats = ({ state, facility }) => (
    <>
        <div className='investor-item font-b3'>
            {state.rfqMang?.allSupplier?.length}{' '}
            {state.rfqMang?.allSupplier?.length > 1 ? 'Suppliers' : 'Supplier'}
        </div>
        <div className='investor-item font-b3'>
            {state.rfqMang?.portList?.length}
            {state.rfqMang?.portList?.length > 1 ? ' Ports' : ' Port'}
        </div>
        <div className='investor-item font-b3'>
            {' '}
            {PropertyFormat(facility?.buyerAverageCreditLimit?.average_credit_limit, amountFormat)} Avg.
            Credit Line Provided (per user)
        </div>
    </>
);

const SupplierHeaderStats = ({ state }) => (
    <>
        <div className='investor-item font-b3'>
            {state.rfqMang?.allBuyer?.length} {state.rfqMang?.allBuyer?.length > 1 ? 'Buyers' : 'Buyer'}
        </div>
        <div className='investor-item font-b3'>
            Total {PropertyFormat(state.transaction?.totalCODAmount?.total_cod_provided, amountFormat)} C.O.D.
            Provided
        </div>
        <div className='investor-item font-b3'>
            Total Volume of {state.transaction?.totalMTTraded?.total_mt_traded} MT Traded
        </div>
    </>
);

const InvestorHeaderStats = ({ facility }) => (
    <>
        <div className='investor-item font-b3'>
            {PropertyFormat(facility.totalTransactionValues?.total_transaction_value, amountFormat)} Total
            Transaction Value
        </div>
        <div className='investor-item font-b3'>
            {facility.totalTransactionValues?.total_invoices_funded} Invoices Funded
        </div>
        <div className='investor-item font-b3'>Total Volume of xxx MT Traded</div>
    </>
);

export const HeaderOrgStats = ({
    platformRole,
    orgName,
    showStatistics,
    state,
    facility,
    visibilityClass = 'd-sm-none d-md-block',
}) => {
    if (platformRole === 'broker') {
        return (
            <div className={`col text-white ${visibilityClass}`}>
                <div className='d-flex flex-row align-items-center'>
                    <div className='investor-name font-b2'>{orgName}</div>
                </div>
            </div>
        );
    }
    if (platformRole === 'buyer') {
        return (
            <div className={`col text-white ${visibilityClass}`}>
                <div className='d-flex flex-row align-items-center'>
                    <div className='investor-name font-b2'>{orgName}</div>{' '}
                    {showStatistics && <BuyerHeaderStats state={state} facility={facility} />}
                </div>
            </div>
        );
    }
    if (platformRole === 'supplier') {
        return (
            <div className='col text-white d-sm-none d-lg-block'>
                <div className='d-flex flex-row align-items-center'>
                    <div className='investor-name font-b2'>{orgName}</div>
                    {showStatistics && <SupplierHeaderStats state={state} />}
                </div>
            </div>
        );
    }
    if (platformRole === 'investor') {
        return (
            <div className={`col text-white ${visibilityClass}`}>
                <div className='d-flex flex-row align-items-center'>
                    <div className='investor-name font-b2'>{orgName}</div>
                    {showStatistics && <InvestorHeaderStats facility={facility} />}
                </div>
            </div>
        );
    }
    if (platformRole === 'internal_ops') {
        return <div className={`col text-white ${visibilityClass}`}></div>;
    }
    return null;
};

export const HeaderNotificationItems = ({ notifications, onItemClick }) =>
    (notifications || []).map((el) => (
        <Dropdown.Item
            key={getNotificationItemKey(el)}
            className='p-0'
            onClick={onItemClick}>
            <div className='request-nofitication'>
                <p className='mb-1'>
                    <div className='d-flex justify-content-between text-start request-nofitication-top'>
                        <span className='float-start mb-0'>
                            <div
                                className={`step-icon me-2 ${getNotificationCategoryClass(
                                    el?.notification_category
                                )} `}></div>
                            <span className='break-spaces'>
                                {PropertyFormat(el?.notification_type, RemoveUnderscoreWithUppercase)}
                            </span>
                        </span>
                        <span className='mb-0 float-end'>
                            {PropertyFormat(el?.created_at, DateFormatWithTime)}
                        </span>
                    </div>
                </p>
                <p className='text-start mb-0 break-spaces notification-p'>{el?.payload?.notification}</p>
            </div>
        </Dropdown.Item>
    ));

export const HeaderRequestItems = ({ requestData, onRequestClick }) =>
    requestData &&
    requestData.length > 0 &&
    requestData.map((request, index) => (
        <Dropdown.Item key={request.ulid} className='p-0' onClick={() => onRequestClick(request)}>
            <div className='p-2 borderBottom request-nofitication'>
                <p className='mb-0'>
                    <div className='d-flex justify-content-between text-start'>
                        <span className='font-b4 font-regular float-start text-neutral-500 mb-0'>
                            <div className={`step-icon color-${index % 3}`}></div>
                            <span className='break-spaces'>{request.request_type}</span>
                        </span>
                        <span className='font-b4 font-regular text-neutral-600 mb-0 float-end'>
                            {PropertyFormat(request?.created_at, DateFormatWithTime)}
                        </span>
                    </div>
                </p>
                <p className='ms-75 font-b2 font-regular text-start text-neutral-100 mb-0 break-spaces'>
                    {request.description}
                </p>
            </div>
        </Dropdown.Item>
    ));
